import { useState } from 'react';
import { Link } from 'react-router';
import { Button, ButtonLink } from '../components/Button';
import { Icon } from '../components/Icon';
import { NoteCarrier } from '../components/illustrations';
import { Paper } from '../components/Paper';
import { EmptyState } from '../components/States';
import { Composer } from '../features/feed/Composer';
import styles from './Page.module.css';
import { FEED_REACH } from '../../shared/region';

export function Compose() {
  const [postedId, setPostedId] = useState<string | null>(null);

  if (postedId) {
    return (
      <Paper>
        <EmptyState
          art={<NoteCarrier />}
          title="Your note is on the board"
          actions={
            <>
              <ButtonLink to={`/p/${postedId}`} variant="primary">
                See your note
              </ButtonLink>
              <Button onClick={() => setPostedId(null)}>Post another</Button>
            </>
          }
        >
          Neighbors within {FEED_REACH} of home can see it now.
        </EmptyState>
      </Paper>
    );
  }

  return (
    <div className={styles.stack}>
      <Link to="/" className={styles.back}>
        <Icon name="back" size={18} />
        Board
      </Link>
      <header>
        <h1 className={styles.pageTitle}>Post a note</h1>
        <p className={styles.lede}>Share something with the people who live around you.</p>
      </header>
      <Composer startOpen onDone={setPostedId} onCancel={() => history.back()} />
    </div>
  );
}
